import { SecsToDhmsPipe } from './../../../modules/shared/pipes/secsToDhms.pipe';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { takeUntil } from 'rxjs/operators';
import { ReportsLoginsRoutes } from './../../models/reports-login.enums';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Subscription, Subject } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ReportService } from '../../reportService';
import { DataService } from '../../dataService';
import { IReportsFilterModel } from '../../models/reports-filter.models';
import { TimeConvertPipe } from 'src/app/modules/shared/pipes/timeConvert.pipe';
import { LocalDatePipe } from 'src/app/shared/pipes/local-date.pipe';
import { DatePipe } from '@angular/common';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as FileSaver from 'file-saver';
import { IReportsDataServiceLeftMenuExpantionModel, IReportsDataServiceTopMenuModel, ReportsDataServiceModelValues, ReportsTopMenuItemsValues } from '../../models/reports-data-service-model';
import { PrintPdfModel } from '../../models/reports-print-pdf-model';
import { ReportsPrintPdfService } from '../../servies/reports-print-pdf.service';
import { IReportsColumnModel } from '../../models/reports.models';

@Component({
    selector: 'app-report-login',
    templateUrl: './reports-login.component.html',
    styleUrls: ['./reports-login.component.scss'],
    providers: [SecsToDhmsPipe]
})
export class ReportsLoginComponent implements OnInit, OnDestroy {


    subscription: Subscription = new Subscription();

    //#region Properties
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    public selectedWindow: string = '';
    public reportName: string = '';
    public dateFrom: any;
    public dateTo: any;
    public reportDate: any;
    public selectedRepFilter = { name: "All", userName: "All", id: 0 };
    public selectedOppStageFilter = { name: "All", id: 0 };
    public selectedDateQuestionChannelfilter = { name: "All", id: 0 };
    public selectedDateCasesChannelfilter = { name: "All", id: 0 };
    public selectedDatePipelineFilter = { name: "All", id: 0 };

    selectedDateCategoryFilter = { name: 'All', id: 0 };
    selectedDateCaseAssNameFilter = { name: "All", id: 0 };
    selectedDatePriorityFilter = { name: 'All', id: 0 };
    selectedDateAccountNameFilter = { businessName: "All", id: 0 };
    selectedDateLeadNameFilter = { businessName: "All", id: 0 };
    selectedDatePhoneModelfilter = { name: "All", id: 0 };


    public showRows: number = 15;
    public pageSize = 15;
    public firstPage = 0;
    public pageNumber = 0;
    public Months: any[] = [];
    public cols: IReportsColumnModel[] = [];
    public tableCols: IReportsColumnModel[] = [];
    public selectedFilterGroup: IReportsFilterModel[] = [];
    public reportsDataCopy = [];
    public reportsData = [];
    public filterByInputValue: any[] = [];
    public totalRecords: number;
    public totalPages: number;
    public results = [];
    public products: any = [];
    public IsShowReportTemplate: boolean = true;
    public noContactFindOrLoadingText = 'Loading....';
    public OrganizationName = "";
    //#endregion
    constructor(public app: AppMainComponent,
        private appMainService: AppMainService,
        private reportService: ReportService,
        private dataService: DataService,
        public localDatePipe: LocalDatePipe,
        private secsToDhmsPipe: SecsToDhmsPipe,
        private timeConvertPipe: TimeConvertPipe,
        private router: ActivatedRoute
    ) {
        this.dataService.getData<IReportsDataServiceTopMenuModel>().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
            if (data.actionType == ReportsDataServiceModelValues.reportsTopMenuItems) {
                if (data.value == ReportsTopMenuItemsValues.print) {
                    this.print();
                }
                else if (data.value == ReportsTopMenuItemsValues.PDF) {
                    this.exportPDF(this.selectedWindow, false);
                }
                else if (data.value == ReportsTopMenuItemsValues.XLS) {
                    this.exportXLS(this.selectedWindow)
                }
                else if (data.value == ReportsTopMenuItemsValues.XLSX) {
                    this.exportXLSX(this.selectedWindow)
                }
                else if (data.value == ReportsTopMenuItemsValues.Refresh) {
                    this.refreshList();
                }
            }
        });
    }

    ngOnInit(): void {
        this.dateFrom = new Date();
        this.dateTo = new Date();

        this.router.paramMap.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((param: any) => {
            const activityType = param.params.type;
            switch (activityType) {
                case ReportsLoginsRoutes.loginHistory:
                    this.selectedWindow = "loginHistory";
                    this.reportName = 'Login History Summary';
                    break;
                case ReportsLoginsRoutes.loginHistoryDetails:
                    this.selectedWindow = "loginHistoryDetails";
                    this.reportName = 'Login History Details Reports';
                    break;
                case ReportsLoginsRoutes.loginHistoryDetail:
                    this.selectedWindow = "loginHistoryDetail";
                    this.reportName = 'Login History Details Reports 2';
                    break;
                case ReportsLoginsRoutes.userDeviceInfo:
                    this.selectedWindow = "userDeviceInfo";
                    this.reportName = 'User Device Info Reports';
                    break;
                case ReportsLoginsRoutes.userMobileAccess:
                    this.selectedWindow = "userMobileAccess";
                    this.reportName = 'User Mobile Access Reports';
                    break;
                default:
                    break;
            }
            this.cols = [];
            this.tableCols = [];
            const selectedUser = this.selectedRepFilter;
            this.reportsData = [];

            this.LoginReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, selectedUser, this.app.companyId);
        });

        this.dataService.sendData<IReportsDataServiceLeftMenuExpantionModel>({ actionType: ReportsDataServiceModelValues.reportsLeftMenuExpansion, value: this.selectedWindow });
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }


    LoginReport(selectedChannelId: number, companyId: number, userId, currentPageSize: number = 15, currentPageNumber: number = 1, selectedWindow: string, selectedUser: object, selectedOrganizationId: number, searchValue?: any) {

        this.appMainService.isShowSpinner('LoginReport');

        this.OrganizationName = this.app.user.organizationName;
        this.reportService.AllLoginReport(selectedChannelId, currentPageSize, currentPageNumber,
            this.formatDate(this.dateFrom),
            this.formatDate(this.dateTo), this.selectedWindow,
            selectedUser, null, this.selectedDateCategoryFilter, this.selectedDateCaseAssNameFilter,
            this.selectedDatePriorityFilter, this.selectedDateAccountNameFilter, this.selectedDateLeadNameFilter, this.selectedDatePhoneModelfilter, searchValue).then(res => {
                this.products = [];
                this.totalRecords = 0;
                this.results = [];
                this.totalPages = 0;
                let { contacts, headers } = res;
                contacts = contacts.length > 0 ? this.filterDDevices(contacts) : [];
                this.IsShowReportTemplate = true;
                this.appMainService.isHideSpinner('LoginReport');
                this.products = JSON.parse(JSON.stringify(contacts));
                this.reportsDataCopy = ParseHelper.DeepCopy(contacts);
                this.reportsData = ParseHelper.DeepCopy(contacts)
                //this.totalRecords = headers['TotalCount'];
                //added for PDF
                this.results = JSON.parse(JSON.stringify(contacts));
                //this.totalPages = headers['TotalPages']
                //added for PDF
                this.settableCols();
                this.setFilterValues();
            }).finally(() => {
                this.appMainService.isHideSpinner('LoginReport');
                this.noContactFindOrLoadingText = 'No Reports Available.';
            });
    }

    filterDDevices(results){
        let dataResults = results;

        if(this.selectedWindow=="userDeviceInfo"){
            dataResults = [];
            results.map(data=>{
                const exist = dataResults.findIndex(d=>d.loginName==data.loginName && d.deviceInformationID==data.deviceInformationID && data.deviceInformationID?.length> 0);

                if(exist==-1){
                    dataResults.push(data);
                }

            })
        }
        let modifiedData = dataResults.reverse().sort((a, b) => (a?.userName > b?.userName) ? 1 : -1);

        return modifiedData;
    }

    settableCols(): void {
        switch (this.selectedWindow) {
            case "userDeviceInfo": {
                this.tableCols = [
                    { id: 1, field: 'loginName', header: 'Login ID', dataType: "string" },
                    { id: 2, field: 'phoneModel', header: 'Phone Model', dataType: "string" },
                    { id: 3, field: 'manufacutrer', header: 'Manufacturer', dataType: "string" },
                    { id: 4, field: 'mobileVersion', header: 'Mobile Version', dataType: "string" },
                    { id: 5, field: 'crmAppVersion', header: 'CRM App Version', dataType: "string" },
                    { id: 6, field: 'dateUpdated', header: 'Last Login Date & Time', dataType: "datetime" },
                    { id: 7, field: 'location', header: 'Location', dataType: "string" },
                ];
                this.cols = [{ id: 0, field: 'userName', header: 'User Name', dataType: "string" },...this.tableCols];
                break;
            }
            case "userMobileAccess": {
                this.tableCols = [
                    { id: 1, field: 'loginName', header: 'Login ID', dataType: "string" },
                    { id: 2, field: 'mobileAccess', header: 'Mobile Access', dataType: "string" },
                    { id: 3, field: 'response', header: 'Response', dataType: "string" },
                    { id: 4, field: 'phoneModel', header: 'Phone Model', dataType: "string" },
                    { id: 5, field: 'crmAppVersion', header: 'CRM App Version', dataType: "string" },
                    { id: 6, field: 'updateDateTime', header: 'Updated Date & Time', dataType: "datetime" },
                    { id: 7, field: 'location', header: 'Location', dataType: "string" },
                ];
                this.cols = [{ id: 0, field: 'userName', header: 'User Name', dataType: "string" },...this.tableCols];
                break;
            }
            case "loginHistory": {
                this.tableCols = [
                    { id: 1, field: 'loginName', header: 'Login ID', dataType: "string" },
                    { id: 2, field: 'loginDate', header: 'Last Login Date & Time', dataType: "datetime" },
                    { id: 3, field: 'totalTimeDuration', header: 'Total Time Duration', dataType: "secsdhms" },
                    { id: 4, field: 'type', header: 'Device Type', dataType: "string" },
                    { id: 5, field: 'location', header: 'Location', dataType: "string" },
                ];
                this.cols = [{ id: 0, field: 'userName', header: 'User Name', dataType: "string" },...this.tableCols];
                break;
            }
            case "loginHistoryDetails": {
                this.tableCols = [
                    { id: 2, field: 'loginName', header: 'Login ID', dataType: "string" },
                    { id: 3, field: 'loginDate', header: 'Login Date & Time', dataType: "datetime" },
                    { id: 5, field: 'outTime', header: 'Logout Date & Time', dataType: "datetime" },
                    { id: 6, field: 'totalTimeDuration', header: 'Total Time Duration', dataType: "secsdhms" },
                    { id: 7, field: 'type', header: 'Device Type', dataType: "string" },
                    { id: 8, field: 'location', header: 'Location', dataType: "string" },
                ];
                this.cols = [{ id: 0, field: 'userName', header: 'User Name', dataType: "string" },...this.tableCols]
                break;
            }
            default: {
                break;
            }
        }
    }

    setFilterValues(): void {
        this.filterByInputValue = [];
        switch (this.selectedWindow) {
            case "userDeviceInfo":
                this.filterByInputValue = [...this.reportsData];
                break;
            default:
                this.filterByInputValue = [...this.reportsData];
                break;
        }
    }

    private formatDate(date: Date) {
        return moment(date).format('MM-DD-YYYY');
    }

    getDifferenceInDays(date1, date2) {
        const diffInMs = Math.abs(date2 - date1);
        return diffInMs / (1000 * 60 * 60 * 24);
    }

    onRemoveFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.onApplyFilter(selectedWindow, selectedFilters);
    }

    onClosePanel(selectedWindow: string): void {
        //this.DownloadReport(selectedWindow);
    }

    onModifyFilterOptions(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        let reportsData: any[] = ParseHelper.DeepCopy(this.reportsDataCopy);

        if (selectedFilters?.length > 0) {
            selectedFilters?.forEach(filt => {

                let field: any = this.cols.find(f => f.field == filt.field);
                if (field?.dataType == "date") {
                    reportsData = reportsData?.filter(x => this.localDatePipe.transform(x[filt.field], 'MM/DD/YYYY') == filt.value) ?? [];
                }
                else {
                    reportsData = reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                }
            });
        }
        this.filterByInputValue = [];
        switch (this.selectedWindow) {
            case "userDeviceInfo":
                this.filterByInputValue = [...reportsData];
                break;
            default:
                this.filterByInputValue = [...reportsData];
                break;
        }
    }

    onApplyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.reportsData = ParseHelper.DeepCopy(this.reportsDataCopy);

        if (selectedFilters?.length > 0) {
            selectedFilters?.forEach(filt => {

                let field: any = this.cols.find(f => f.field == filt.field);
                if (field?.dataType == "date") {
                    this.reportsData = this.reportsData?.filter(x => this.localDatePipe.transform(x[filt.field], 'MM/DD/YYYY') == filt.value) ?? [];
                }
                else {
                    this.reportsData = this.reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                }
            });
        }
        this.setFilterValues();
    }

    refreshList(){
        this.selectedFilterGroup = [];
        this.LoginReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, this.selectedRepFilter, this.app.companyId);
    }

    onChangeRange(selectedWindow: string, event: any): void {
        this.dateFrom = event.dateFrom;
        this.dateTo = event.dateTo;
        //this.selectedDateFilter = event;
        const selectedUser = this.selectedRepFilter;
        this.LoginReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, selectedWindow, selectedUser, this.app.companyId);
    }

    print() {
        this.appMainService.isShowSpinner('Print');
        this.exportPDF(this.selectedWindow, true);
        this.appMainService.isHideSpinner('Print');
    }

    exportPDF(selectedWindow: string, isPrintFlag = false) {
        this.PDFLoginReport(selectedWindow, isPrintFlag, "NoExcel");
    }

    exportXLS(selectedWindow: string) {
        this.PDFLoginReport(selectedWindow, false, "exportXLSX");
    }

    exportXLSX(selectedWindow: string) {
        this.PDFLoginReport(selectedWindow, false, "exportXLSX");
    }

    PDFLoginReport(selectedWindow: string, isPrintFlag: boolean, isexportXLS: string) {
        let dataResult = [];
        let modifiedData = [];
        let reportsData = ParseHelper.DeepCopy(this.reportsData);
        reportsData.map(rowData => {
            let obj = {};
            let data = rowData;

            this.cols.map(cols => {
                if (cols.dataType == "datetime")
                    {
                        data[cols.field] = this.localDatePipe.transform(data[cols.field]);
                        obj[cols.header] = data[cols.field];
                    }
                else if (cols.dataType == "secsdhms")
                    {
                        data[cols.field] = this.secsToDhmsPipe.transform(data[cols.field]);
                        obj[cols.header] = data[cols.field];
                    }
                else
                    {
                        obj[cols.header] = rowData[cols.field];
                    }
            });

            if (obj) {
                modifiedData.push(data);
                dataResult.push(obj);
            }
        });

        if (isexportXLS === "exportXLS" || isexportXLS === "exportXLSX") {

            if (isexportXLS === "exportXLSX") {
                import("xlsx").then(xlsx => {
                    const worksheet = xlsx.utils.json_to_sheet(dataResult);
                    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                    this.saveAsExcelFilexlsx(excelBuffer, this.reportName);
                });
            }

            if (isexportXLS === "exportXLS") {
                import("xlsx").then(xlsx => {
                    const worksheet = xlsx.utils.json_to_sheet(dataResult);
                    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xls', type: 'array' });
                    this.saveAsExcelFilexls(excelBuffer, this.reportName);
                });
            }
        } else {
            let pdfcolumns = [];
            this.cols.map(cols => {
                pdfcolumns.push({ dataKey: cols.field, header: cols.header });
            })

            //Print/PDF
            ReportsPrintPdfService.openOrExportAsPDF(pdfcolumns, modifiedData, this.OrganizationName, this.dateFrom, this.dateTo, this.reportName, null, null, isPrintFlag);
            this.noContactFindOrLoadingText = 'No Reports Available.';
        }
    }

    saveAsExcelFilexls(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xls';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
    saveAsExcelFilexlsx(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }

    private saveAsPdfFile(buffer: any, fileName: string): void {
        buffer.save(fileName + '.pdf');
    }

}
